/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function Account() {
  const [design, setDesign] = useState(false);
  const [code, setCode] = useState(false);
  const [develop, setDevelop] = useState(false);

  const handleSetDesign = () => setDesign(!design);
  const handleSetCode = () => setCode(!code);
  const handleSetDevelop = () => setDevelop(!develop);

  const customButtonStyles = ({
    functions: { pxToRem, rgba },
    borders: { borderWidth },
    palette: { transparent, info },
    typography: { size },
  }) => ({
    width: pxToRem(164),
    height: pxToRem(130),
    borderWidth: borderWidth[2],
    mb: 1,
    ml: 0.5,

    "&.MuiButton-contained, &.MuiButton-contained:hover": {
      boxShadow: "none",
      border: `${borderWidth[2]} solid ${transparent.main}`,
    },

    "&:hover": {
      backgroundColor: `${transparent.main} !important`,
      border: `${borderWidth[2]} solid ${info.main} !important`,
      color: rgba(info.main, 0.75),
    },

    "& .material-icons-round": {
      fontSize: `${size["3xl"]} !important`,
    },
  });

  return (
    <MDBox>
      <MDBox width="80%" textAlign="center" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            Perfect! Let's take a look at the company details provided.
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          This information was submitted by the applicant.
        </MDTypography>
      </MDBox>
      <MDBox >
        <Grid container spacing={3} justifyContent>
            <Grid item xs={12} sm={12} md={6}>
              <MDTypography variant="body2" color="text">
                Start-up Entity Legal Name
              </MDTypography>
                Tiles AI
              <MDTypography variant="body2" color="text">
                Start-up Entity Address
              </MDTypography>
                Hudiburg Circle, #C, 417, Oklahoma City, OK 73108
              <MDTypography variant="body2" color="text">
                EIN
              </MDTypography>
                839472098
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

            <MDTypography variant="body2" color="text">
              Date Start-up Entity was established in US
            </MDTypography>
              10/16/2021
            <MDTypography variant="body2" color="text">
              Number of Full-time Employees
            </MDTypography>
              13
            <MDTypography variant="body2" color="text">
              Ownership Stake in Company
            </MDTypography>
              35%
            <MDTypography variant="body2" color="text">
              Explanatory Statement
            </MDTypography>
              I am the founder and the boss. Business would fall apart without me.
          </Grid>

        </Grid>
        <Divider sx={{ margin: 5 }} />
        <MDBox mt={2}>
          <Grid container spacing={3} justifyContent>
            <Grid item xs={12} md={4}>
              {/* <FormField type="text" label="Street Name" InputLabelProps={{ shrink: true }} /> */}
              <MDTypography variant="body2" color="text">
                Did Tiles AI receive a Qualified Investment of more than $250k in the last 18 months?
              </MDTypography>
                Yes
            </Grid>
            <Grid item xs={12} md={4}>
              <MDTypography variant="body2" color="text">
                Amount of Qualified Investments
              </MDTypography>
                $430,000
            </Grid>
            <Grid item xs={12} md={4}>
              <MDTypography variant="body2" color="text">
                Date Qualified Investment was received
              </MDTypography>
                02/14/2022
            </Grid>
            </Grid>
          <Divider sx={{ margin: 5 }} />

          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <MDTypography variant="body2" color="text">
                Did Tiles AI receive a Qualified Government Award or Grant of more than $250k in the last 18 months?
              </MDTypography>
                Yes
            </Grid>
            <Grid item xs={12} md={4}>
              <MDTypography variant="body2" color="text">
                Amount of Qualified Government Award or Grant
              </MDTypography>
                $230,000
            </Grid>
            <Grid item xs={12} md={4}>
              <MDTypography variant="body2" color="text">
                Date Qualified Grant or Award was received
              </MDTypography>
                02/12/2022
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default Account;
